import React from "react";
import ReactDatePicker, { DatePickerProps } from "react-datepicker";

import calendarIcon from "../../assets/images/calenderIcon.svg";
import "./index.css";

export default function DatePicker(props: DatePickerProps) {
  return (
    <div className="pl-3 position-relative">
      <ReactDatePicker  {...props} className={`custom-datepicker ${props.className ? props.className : ''}`} />
      <img className="calendar-icon" src={calendarIcon} alt="Calendar Icon" />
    </div>
  );
}
